import React, { FC, useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

interface CashCancellationDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
  title?: string;
  content?: string;
}

const CashCancellationDialog: FC<CashCancellationDialogProps> = ({
  open,
  onCancel,
  onConfirm,
  title,
  content,
}) => {
  const [reason, setReason] = useState("");

  // Reset reason when dialog opens/closes
  useEffect(() => {
    if (!open) {
      setReason("");
    }
  }, [open]);

  const handleConfirm = () => {
    if (reason.trim()) {
      onConfirm(reason.trim());
      setReason("");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="cancel-dialog-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="cancel-dialog-title">
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          {title}
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          {content}
        </DialogContentText>
        <TextField
          autoFocus
          required
          fullWidth
          label="Grund für die Stornierung"
          placeholder="z.B. Versehentlich gebucht, Betrag falsch, etc."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          multiline
          rows={3}
          variant="outlined"
          helperText="Bitte geben Sie einen Grund für die Stornierung an"
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} color="inherit">
          Abbrechen
        </Button>
        <Button 
          onClick={handleConfirm} 
          variant="contained" 
          color="error"
          disabled={!reason.trim()}
        >
          Ja, Stornieren
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CashCancellationDialog;
